var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"earth-container"},_vm._l((_vm.picLists),function(item,index){return _c('div',{key:index,class:_vm.picSign[index]},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.sceneName))]),_c('img',{staticClass:"pic",attrs:{"src":item.mainImg},on:{"click":function($event){return _vm.handleScene(item)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }